export enum PermissionState {
    granted = 'granted',
    denied = 'denied'
}
